module.exports = __webpack_public_path__ + "static/mission-text_2-729163b6940e662adb583433fd051e66.png";